import { FormattedMessage } from 'react-intl';

import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

import Spacings from '~/modules/ui-kit/spacings';
import ShiftCancellationButton from '~/components/ShiftCancellationButton';
import messages from './messages';
import styles from './styles.module.css';

type ShiftDetailCardCancellationProps = {
  shiftId: number;
  isCanceled: boolean;
};

const ShiftDetailCardCancellation = (
  props: ShiftDetailCardCancellationProps
) => (
  <Card classes={{ root: props.isCanceled ? styles.canceled : undefined }}>
    <Spacings.Inset>
      <Spacings.Stack>
        <Typography variant="subtitle2">
          {props.isCanceled ? (
            <FormattedMessage {...messages.titleCanceled} />
          ) : (
            <FormattedMessage {...messages.title} />
          )}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {props.isCanceled ? (
            <FormattedMessage {...messages.descriptionCanceled} />
          ) : (
            <FormattedMessage {...messages.description} />
          )}
        </Typography>
        {!props.isCanceled ? (
          <div>
            <ShiftCancellationButton shiftId={props.shiftId} />
          </div>
        ) : null}
      </Spacings.Stack>
    </Spacings.Inset>
  </Card>
);

export default ShiftDetailCardCancellation;
